<template>
  <v-card>
    <v-card-text class="pa-0">
      <v-container class="pb-0 pt-0">
        <v-row>
          <v-col cols="12" class="pb-0 pt-0">

            <v-tabs
              background-color="transparent"
              slider-color="white"
              centered
            >
              <v-tab>
                Preview
              </v-tab>
              <v-tab>
                Source
              </v-tab>
              <v-tab-item>
                <v-row>
                  <v-col :cols="canAssignToOtherPeople ? 2 : 4">
                    <date-picker
                      v-model="localModelValue.date"
                      label="Date"
                      :readonly="false"
                      class="pr-2"
                      style="min-width: 140px"
                    />
                  </v-col>
                  <v-col :cols="canAssignToOtherPeople ? 2 : 4">
                    <v-select
                      v-model="localModelValue.type"
                      :items="Object.entries(TYPE_OPTIONS)"
                      item-value="0"
                      item-text="1"
                      :item-disabled="item => item[0] === 'personal' && (localModelValue.task_id && localModelValue.author_id !== operatorId)"
                      label="Type"
                      hide-details
                    />
                  </v-col>
                  <v-col :cols="canAssignToOtherPeople ? 2 : 4">
                    <v-select
                      v-model="localModelValue.status"
                      :items="Object.entries(STATUS_OPTIONS)"
                      item-value="0"
                      item-text="1"
                      label="Status"
                      hide-details
                      />
                  </v-col>
                  <v-col
                    v-if="canAssignToOtherPeople"
                    cols="6"
                  >
                    <v-row class="mx-0">
                      <v-autocomplete
                        v-model="localModelValue.user_id"
                        :items="Object.values(operatorsById)"
                        clearable
                        :item-text="getOperatorName"
                        item-value="user_id"
                        :item-disabled="user => !user.is_active"
                        label="Assignee"
                        hide-details
                      />
                      <v-btn
                        v-text="'Assign to me'"
                        class="align-self-end"
                        text
                        plain
                        small
                        :disabled="localModelValue.user_id === operatorId"
                        @click="localModelValue.user_id = operatorId"
                      />
                    </v-row>
                  </v-col>
                </v-row>
                <v-row
                  :class="canAssignToOtherPeople ? 'justify-end' : ''"
                >
                  <v-col
                    cols="4"
                  >
                    <v-text-field
                      v-model="localModelValue.player_login"
                      label="Login"
                      :readonly="isLoginReadonly"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      v-model="localModelValue.priority"
                      :items="Object.entries(PRIORITY_OPTIONS)"
                      item-value="0"
                      item-text="1"
                      label="Priority"
                      hide-details
                    />
                  </v-col>
                  <v-col
                    v-if="canAssignToOtherPeople"
                    cols="6"
                  >
                    <v-row class="mx-0">
                      <v-autocomplete
                        v-model="localModelValue.performer_id"
                        :items="Object.values(operatorsById)"
                        clearable
                        :item-text="getOperatorName"
                        item-value="user_id"
                        :item-disabled="user => !user.is_active"
                        label="Performer"
                        hide-details
                      />
                      <v-btn
                        v-text="'Select myself'"
                        class="align-self-end"
                        text
                        plain
                        small
                        :disabled="localModelValue.performer_id === operatorId"
                        @click="localModelValue.performer_id = operatorId"
                      />
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-combobox
                      v-model="localModelValue.tags"
                      label="Tags"
                      :items="tagSuggestions"
                      multiple
                      hide-details
                    />
                  </v-col>
                </v-row>
                <vue-editor v-model="localModelValue.body" :editor-toolbar="editorToolbar" />
              </v-tab-item>
              <v-tab-item>
                <v-textarea v-model="localModelValue.body" label="Body" />
              </v-tab-item>
            </v-tabs>

          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn
        color="blue darken-1"
        text
        :loading="isLoading"
        @click="$emit('close')"
      >
        Cancel
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        :disabled="isPristine"
        :loading="isLoading"
        @click="$emit('save', localModelValue)"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { useDialogForm } from '@/components/core/DrawerDialog';
import { STATUS_OPTIONS, TYPE_OPTIONS, PRIORITY_OPTIONS } from '../consts'
import { getOperatorName } from '../utils'
import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

export default {
  components: {
    DatePicker
  },
  props: {
    task: {
      type: Object,
      default: () => ({})
    },
    operatorsById: {
      type: Object,
      default: () => ({})
    },
    tagSuggestions: {
      type: Array,
      required: true,
    },
    operatorId: Number,
    canAssignToOtherPeople: Boolean,
    isLoading: Boolean,
    isLoginReadonly: Boolean,
  },

  data() {
    return {
      STATUS_OPTIONS,
      TYPE_OPTIONS,
      PRIORITY_OPTIONS,

      editorToolbar: [
        [ { header: [ false, 1, 2, 3, 4, 5, 6 ] } ],
        [ 'bold', 'italic', 'underline', 'strike' ],
        [ { color: [] } ],
        [ { list: 'ordered' }, { list: 'bullet' }, { align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' } ],
        [ 'link', 'code-block' ]
      ],
    }
  },

  setup(props) {
    const { isPristine, localModelValue } = useDialogForm(props.task);

    return {
      isPristine,
      localModelValue
    }
  },
  methods: {
    getOperatorName
  }
}
</script>
